export default "__VITE_ASSET__oLiAA5yS__"